import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { useKeycloak } from '../context/KeycloakContext';
import { resolveReturnTo } from '../lib/utils/login-redirect';

export function SSOCallback() {
	const { t } = useTranslation();
	const { keycloak, errors } = useKeycloak();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (!keycloak?.didInitialize) {
			// Keycloak is still initializing, wait for it to finish
			return;
		}
		console.log('SSO Callback - Keycloak state:', {
			token: keycloak?.token,
			authenticated: keycloak?.authenticated,
			identity: keycloak?.idTokenParsed,
			idToken: keycloak?.idToken,
		});
		if (keycloak?.authenticated) {
			setTimeout(() => {
				navigate(resolveReturnTo(location.search), { replace: true });
			}, 500); // redirect after some second to make sure user can see Login Successfull message
		}
	}, [keycloak, navigate, location.search]);

	return (
		<div className="flex items-center justify-center h-screen">
			<div className="text-center">
				{!keycloak?.didInitialize && (
					<>
						<h1 className="text-2xl font-bold mb-4">{t('auth.sso.processingTitle')}</h1>
						<p className="text-gray-600">{t('auth.sso.processingBody')}</p>
					</>
				)}
				{keycloak?.didInitialize && errors.length > 0 && (
					<>
						<h1 className="text-2xl font-bold mb-4 text-red-600">{t('auth.sso.failedTitle')}</h1>
						<p className="text-gray-600">{t('auth.sso.failedBody')}</p>
						<ul className="mt-4 text-left text-sm text-gray-500">
							{errors.map((error) => (
								<li key={error}>{error}</li>
							))}
						</ul>
					</>
				)}
				{keycloak?.didInitialize && keycloak?.authenticated && (
					<>
						<h1 className="text-2xl font-bold mb-4 text-green-600">{t('auth.sso.successTitle')}</h1>
						<p className="text-gray-600">{t('auth.sso.successBody')}</p>
					</>
				)}
				{keycloak?.didInitialize && !keycloak?.authenticated && errors.length === 0 && (
					<>
						<h1 className="text-2xl font-bold mb-4 text-yellow-600">{t('auth.sso.unknownTitle')}</h1>
						<p className="text-gray-600">{t('auth.sso.unknownBody')}</p>
					</>
				)}
			</div>
		</div>
	);
}
